import React from "react";
import { Warning, Error, CheckCircle } from "@material-ui/icons";
import "./highlightbanner.css";

export const HighlightBanner = ({
  type = "warning",
  children,
  className = "",
}) => {
  const renderIcon = () => {
    switch (type) {
    case "warning":
      return <Warning className="highlight-banner__icon" />;
    case "error":
      return <Error className="highlight-banner__icon" />;
    case "success":
      return <CheckCircle className="highlight-banner__icon" />;
    default:
      return <Warning className="highlight-banner__icon" />;
    }
  };

  return (
    <div
      className={`highlight-banner highlight-banner--${type} ${className}`}
      role="alert"
    >
      <div className="highlight-banner__icon-container">{renderIcon()}</div>
      <div className="highlight-banner__content">{children}</div>
    </div>
  );
};

export default HighlightBanner;
